import axios from "axios";
import { request } from "@/utils/request";

/**
 * 查询
 * @param {*} data
 * @returns
 */
export function selectBanner(data) {
  return request({
    url: `/admin/banner/select`,
    method: "POST",
    data,
    // isEncrypt:false,
    // isDecrypt:false
  });
}

/**
 * 新增
 * @param {*} data
 * @returns
 */
export function addBanner(data) {
  return request({
    url: `/admin/banner/add`,
    method: "POST",
    data,
  });
}

/**
 * 更改
 * @param {*} data
 * @returns
 */
export function updateBanner(data) {
  return request({
    url: `/admin/banner/update`,
    method: "POST",
    data,
  });
}

/**
 * 删除
 * @param {*} data
 * @returns
 */
export function deleteBanner(data) {
  return request({
    url: `/admin/banner/delete`,
    method: "POST",
    data
  });
}
